import React, { useState } from "react"
import { useSelector } from "react-redux"
import Alert from "@mui/material/Alert"
import Modal from "react-bootstrap/Modal"
import CloseIcon from "@mui/icons-material/Close"
import { Forms } from "../../../../Reuseable/Forms"
import { Validators } from "../../../../../Utilities/validator"
import AdminDashBoardWrapper from "../Style"
import { api } from "../../../../../Services/api"
import newsletter from "../../../../../assets/images/AdminImages/User/Newsletter-bro.svg"
import { client } from "../../../../.."
import { key } from "../../../../../data/queryKeys"

const AddNewuser = ({ CloseAddUser, showAddUser, setShowNoUser }) => {
  const authToken = useSelector((state) => state.Auth.authToken)

  const [changeInForm, setChangeInForm] = useState(false)
  const [confirmMessage, setConfirmMessage] = useState("")
  const [subUserEmail, setsubUserEmail] = useState("")
  const [loading, setLoading] = useState(false)
  const [exsistUserAlert, setExsistuserAlert] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")

  const CloseConfirmMessage = () => setConfirmMessage(false)
  const OpenConfirmMessage = () => {
    setConfirmMessage(true);
    setTimeout(() => {
      CloseConfirmMessage();
      setsubUserEmail("");
      client.invalidateQueries({
        queryKey: [key.get_all_members],
      });
    }, 2000); // Automatically close after 2 seconds
  }

  let formArr = [
    {
      label: "Name",
      name: "name",
      type: "text",
      placeholder: "Name",
      validators: [
        { check: Validators.required, message: "This Field is required" },
        // Only allow up to 30 characters
        {
          check: (val) => val.length <= 30,
          message: "Name must be at most 30 characters"
        }
      ],
      error: false,
      errormsg: "",
      value: "",
      maxLength: 30, // restrict input to 30 characters
      show: true
    },
    {
      label: "E-mail",
      name: "email",
      type: "email",
      placeholder: "Email",
      validators: [
        { check: Validators.required, message: "This Field is required" },
        // Gmail validation: must be a valid Gmail address
        {
          check: (val) =>
            /^([a-zA-Z0-9_.+-])+@gmail\.com$/.test(val),
          message: "Email must be a valid Gmail address"
        }
      ],
      error: false,
      errormsg: "",
      value: "",
      show: true
    }
  ]

  const SubmitSubUser = (form, valid) => {
    if (valid) {
      setExsistuserAlert(false)
      setLoading(true)
      setsubUserEmail(form.email)
      let Obj = {
        emailId: form.email,
        personname: form.name
      }

      api
        .post("/trackingadmin/subuser", Obj, {
          headers: {
            authorizationtoken: ` ${authToken}`
          }
        })
        .then(function (response) {
          if (response.status === 200) {
            if (response.data.status === true) {
              setShowNoUser(false)
              setLoading(false)
              CloseAddUser()
              OpenConfirmMessage()
              client.invalidateQueries({
                queryKey: [key.get_all_members]
              })
            } else {
              setLoading(false)
              setExsistuserAlert(true)
              setErrorMessage(response.data.message)
            }
          }
        })
        .catch(function (error) {
          console.log("[SubmitSubUser] Error-->", error)
          setLoading(false)
          setExsistuserAlert(true)
          setErrorMessage("The user with this same email already exists.")
        })
    }
  }

  return (
    <>
      <Modal
        show={confirmMessage}
        onHide={() => {
          CloseConfirmMessage()
          setsubUserEmail("")
          client.invalidateQueries({
            queryKey: [key.get_all_members]
          })
        }}
      >
        <AdminDashBoardWrapper>
          <div className='p-2'>
            <CloseIcon
              className='float-end mt-1'
              onClick={CloseConfirmMessage}
              style={{ color: "#4EB6EE", cursor: "pointer" }}
            />
            <div className='success-message p-5'>
              <div className='email-image mb-3'>
                <img src={newsletter} alt='news-letter' />
              </div>
              <div className='email-text my-2'>
                {/* <strong>your invite has been sent to the following user</strong> */}
                <strong>The following user has been added successfully</strong>
              </div>
              <div>
                <span className='message-email'>{subUserEmail}</span>
              </div>
            </div>
          </div>
        </AdminDashBoardWrapper>
      </Modal>

      <Modal
        show={showAddUser}
        onHide={() => {
          CloseAddUser()
          setExsistuserAlert(false)
        }}
      >
        <AdminDashBoardWrapper>
          <div className='p-2'>
            <div className='px-3 pt-2' style={{ color: "#4EB6EE", fontSize: "20px" }}>
              <span>Add new user</span>
              <CloseIcon
                className='float-end mt-1'
                onClick={() => {
                  CloseAddUser()
                  setExsistuserAlert(false)
                }}
                style={{ cursor: "pointer" }}
              />
              {exsistUserAlert ? (
                <div className='px-4 pt-3'>
                  <Alert variant='filled' severity='warning'>
                    {errorMessage}
                  </Alert>
                </div>
              ) : null}
            </div>
            <Forms
              title={""}
              formArr={formArr}
              //future use
              // submitBtn={"Send Request"}
              submitBtn={"Add User"}
              submitted={true}
              loading={loading}
              onSubmit={SubmitSubUser}
              changeInForm={changeInForm}
              setChangeInForm={setChangeInForm}
            />
          </div>
        </AdminDashBoardWrapper>
      </Modal>
    </>
  )
}

export default AddNewuser
